// import Vue from "vue";
//
// Vue.filter('statusFormat', function (value) {
//     return value ? 'fas fa-check' : 'fas fa-times';
// });
//
// Vue.filter('statusClass', function (value) {
//     return value ? 'success' : 'danger';
// });
//
// Vue.filter('formatDate', function (value) {
//     return value ? new Date(value).toLocaleDateString('es-ES') : '';
// });

export const filters = {
    capitalize(value) {
        if (!value) return '';
        return value.toString().charAt(0).toUpperCase() + value.slice(1);
    },

    uppercase(value) {
        if (!value) return '';
        return value.toString().toUpperCase();
    },

    lowercase(value) {
        if (!value) return '';
        return value.toString().toLowerCase();
    },

    truncate(value, length = 50) {
        if (!value) return '';
        return value.length > length ? value.substring(0, length) + '...' : value;
    },

    formatDate(value) {
        if (!value) return '';
        return new Date(value).toLocaleDateString('es-ES');
    },

    formatDateTime(value) {
        if (!value) {
            return '';
        }
        const date = new Date(value);

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${day}/${month}/${year} ${hours}:${minutes}`;
    },

    yesNo(value) {
        if (value) {
            return '<i class="fas fa-check text-success"></i>';
        } else {
            return '<i class="fas fa-times text-danger"></i>';
        }
    }
};
